(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcpatdocs.factory:PatdocsHelper
   *
   * @description
   *
   */
  angular
    .module('vcpatdocs')
    .factory('PatdocsHelper', PatdocsHelper);


  PatdocsHelper.$inject = ['Patdocs', '$uibModal', '$log', 'Rlog'];

  function PatdocsHelper(Patdocs, $uibModal, $log, Rlog) {
    let PatdocsHelperBase = {};

    PatdocsHelperBase.addReferral = addReferral;
    PatdocsHelperBase.addAide = addAide;
    // PatdocsHelperBase.addBiopsyReferral = addBiopsyReferral;


    function addReferral(consultid, clientid) {
      let dialog = $uibModal.open({
        template: `<div class="modalspacer">
            <div style="text-align: right">
              <button class="btn btn-danger" ng-click="vm.$uibModalInstance.close()" uib-tooltip="Fenster schließen">
                <i class="fa fa-remove"></i>
              </button>
            </div>
            <newref consultid="vm.consultid" patientid="vm.clientid" mode="patient" modal="vm.$uibModalInstance"></newref>
            <reflist consultid="vm.consultid"></reflist>
            </div>`,
        controllerAs: 'vm',
        controller: ['consultid', 'clientid', '$uibModalInstance', function (lconsultid, lclientid, $uibModalInstance) {
          let vm = this;
          vm.patdocs = {};
          vm.consultid = lconsultid;
          vm.clientid = lclientid;
          vm.$uibModalInstance = $uibModalInstance;
        }],
        resolve: {
          consultid: function () {
            return consultid;
          },
          clientid: function () {
            return clientid;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
    }

    function addAide(consultid, clientid) {
      let dialog = $uibModal.open({
        template: `<div class="modalspacer">
            <div style="text-align: right">
              <button class="btn btn-danger" ng-click="vm.$uibModalInstance.close()" uib-tooltip="Fenster schließen">
                <i class="fa fa-remove"></i>
              </button>
            </div>
            <newaide consultid="vm.consultid" patientid="vm.clientid"  mode="patient"  modal="vm.$uibModalInstance"></newaide>
            <aidelist consultid="vm.consultid"></aidelist>
            </div>`,
        controllerAs: 'vm',
        controller: ['consultid', 'clientid', '$uibModalInstance', function (lconsultid, lclientid, $uibModalInstance) {
          let vm = this;
          vm.patdocs = {};
          vm.consultid = lconsultid;
          vm.clientid = lclientid;
          vm.$uibModalInstance = $uibModalInstance;
        }],
        resolve: {
          consultid: function () {
            return consultid;
          },
          clientid: function () {
            return clientid;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
    }



    // add patho referral for biopsies
    function oldaddBiopsyReferral() {
      var biolabels = [];
      var label;
      var i;
      if (!vm.patient.openConsult.hasOwnProperty('referrals') || !(vm.patient.openConsult.referrals instanceof Array)) {
        vm.patient.openConsult.referrals = [];
      }

      if (!vm.patient.openConsult.hasOwnProperty('newreferral')) {
        vm.patient.openConsult.newreferral = {};
      }

    }

    return PatdocsHelperBase;
  }
}());
